export default __webpack_public_path__ + "static/media/BloodPressure.751e5b84.svg";